import type { i18n as I18n } from "i18next";
import en from "@/locales/en/puzzle-types/chess_mate.json";
import fr from "@/locales/fr/puzzle-types/chess_mate.json";

export const CHESS_NS = "puzzle-types/chess_mate";

/** Adds this type's translations to an initialised i18next instance (idempotent). */
export function registerChessMateTranslations(i18n: I18n): void {
  if (!i18n.hasResourceBundle("en", CHESS_NS))
    i18n.addResourceBundle("en", CHESS_NS, en, true, true);
  if (!i18n.hasResourceBundle("fr", CHESS_NS))
    i18n.addResourceBundle("fr", CHESS_NS, fr, true, true);
}
